import script from "./WebOrdersView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WebOrdersView.vue?vue&type=script&lang=ts&setup=true"

import "./WebOrdersView.vue?vue&type=style&index=0&id=e554e0e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e554e0e2"]])

export default __exports__